module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-3c6e294d.png";